import { useAppSelector } from 'app/hooks';
import FeatureTitleBar from 'components/common/FeatureTitleBar';
import StatusHeader from 'components/common/StatusHeader';
import { selectIsEditMode } from 'features/common/editModeSlice';
import { DisplayControlGroup } from 'features/DisplayControlGroup/models';
import { useEffect, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import TableList from './components/TableList';
import './css.scss';
import service from './services';
function List() {
  const { t } = useTranslation();
  const history = useHistory();
  const [dataTable, setDataTable] = useState<DisplayControlGroup[] | []>([]);

  // selectors
  const isEditMode = useAppSelector(selectIsEditMode);

  async function filterAPI() {
    await service.get().then((res) => {
      setDataTable(res.data);
    });
  }

  // first load page
  useEffect(() => {
    async function getDataTable() {
      filterAPI();
    }
    getDataTable();
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  return (
    <div className="page-wrapper">
      <div className="page-header">
        <StatusHeader onAction={() => history.push('/')} />
      </div>
      <div className={`page-main ${isEditMode ? 'reedit-mode-wrapper' : ''}`}>
        <div className="page-content store-setting-page d-flex flex-column">
          <div className="mb-3">
            <FeatureTitleBar title={t('DisplayControlGroup.Title')}></FeatureTitleBar>
          </div>

          {dataTable && <TableList dataTable={dataTable} setDataTable={setDataTable}></TableList>}
        </div>
      </div>
    </div>
  );
}
export default List;
